import createSimpleComponent from '../createSimpleComponent'

import cls from './button-container.module.scss'

export default createSimpleComponent({
  displayName: 'ButtonContainer',
  className: cls.wrapper,
  Component: 'div',
})
